export const OBTENER_CATEGORIAS = 'categorias_traer_todas';
export const ERROR = 'categorias_error';
export const LOADING = 'categorias_loading';